export const CREATE_TITLE_MUTATION = `
  mutation CreateTitle($object: titles_insert_input!) {
    insert_titles_one(object: $object) {
      id
      title_name
      title_code
      title_description
      title_status
      company_id
      created_at
    }
  }
`;

export const UPDATE_TITLE_MUTATION = `
  mutation UpdateTitle($id: Int!, $_set: titles_set_input!) {
    update_titles_by_pk(pk_columns: { id: $id }, _set: $_set) {
      id
      title_name
      title_code
      title_description
      title_status
      company_id
      created_at
    }
  }
`;

export const DELETE_TITLE_MUTATION = `
  mutation DeleteTitle($id: Int!) {
    delete_titles_by_pk(id: $id) {
      id
      title_name
    }
  }
`;
